import api from './client';

export const auth = {
  register: d => api.post('/auth/register', d),
  login: d => api.post('/auth/login', d),
  me: () => api.get('/auth/me'),
  updateMe: d => api.patch('/auth/me', d),
  googleLogin: () => { window.location.href = '/api/auth/google'; },
};

export const projects = {
  list: () => api.get('/projects'),
  get: id => api.get(`/projects/${id}`),
  create: d => api.post('/projects', d),
  update: (id, d) => api.patch(`/projects/${id}`, d),
  delete: id => api.delete(`/projects/${id}`),
  stats: id => api.get(`/projects/${id}/stats`),
  addMember: (id, d) => api.post(`/projects/${id}/members`, d),
  removeMember: (id, userId) => api.delete(`/projects/${id}/members/${userId}`),
  updateMemberRole: (id, userId, role) => api.patch(`/projects/${id}/members/${userId}`, { role }),
  generateInvite: (id, role = 'member') => api.post(`/projects/${id}/invite`, { role }),
  getInvitation: token => api.get(`/projects/invitations/${token}`),
  acceptInvitation: token => api.post(`/projects/invitations/${token}/accept`),
};

export const projectGroups = {
  list: () => api.get('/project-groups'),
  create: d => api.post('/project-groups', d),
  update: (id, d) => api.patch(`/project-groups/${id}`, d),
  delete: id => api.delete(`/project-groups/${id}`),
  addProject: (id, projectId) => api.post(`/project-groups/${id}/projects`, { projectId }),
  removeProject: (id, projectId) => api.delete(`/project-groups/${id}/projects/${projectId}`),
};

export const tasks = {
  list: params => api.get('/tasks', { params }),
  get: id => api.get(`/tasks/${id}`),
  create: d => api.post('/tasks', d),
  update: (id, d) => api.patch(`/tasks/${id}`, d),
  delete: id => api.delete(`/tasks/${id}`),
  addComment: (id, d) => api.post(`/tasks/${id}/comments`, d),
  logTime: (id, d) => api.post(`/tasks/${id}/timelogs`, d),
  bulkMove: d => api.patch('/tasks/bulk/move', d),
};

export const boards = {
  list: projectId => api.get('/boards', { params: { project: projectId } }),
  get: id => api.get(`/boards/${id}`),
  update: (id, d) => api.patch(`/boards/${id}`, d),
};

export const sprints = {
  list: projectId => api.get('/sprints', { params: { project: projectId } }),
  create: d => api.post('/sprints', d),
  update: (id, d) => api.patch(`/sprints/${id}`, d),
  start: (id, d) => api.post(`/sprints/${id}/start`, d),
  complete: (id, d) => api.post(`/sprints/${id}/complete`, d),
  delete: id => api.delete(`/sprints/${id}`),
};

export const users = {
  search: q => api.get('/users/search', { params: { q } }),
};

function authFileUrl(path) {
  const token = localStorage.getItem('token');
  const separator = path.includes('?') ? '&' : '?';
  return token ? `https://backend.tracker.turtton.ru${path}${separator}token=${encodeURIComponent(token)}` : path;
}

export const files = {
  list: projectId => api.get('/files', { params: { project: projectId } }),
  upload: (projectId, formData, onProgress) =>
    api.post('/files/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress,
    }),
  download: id => authFileUrl(`/api/files/${id}/download`),
  preview: id => authFileUrl(`/api/files/${id}/preview`),
  update: (id, d) => api.patch(`/files/${id}`, d),
  delete: id => api.delete(`/files/${id}`),
};

export const workload = {
  list: params => api.get('/workload', { params }),
  userTasks: (userId, params) => api.get(`/workload/user/${userId}`, { params }),
};
